import { useEffect, useState } from 'react';
import Asynchronous from './type-head';
import InputDetail from './detail-input';
import moment from 'moment';

import '../base/list.css';
import { makeStyles } from 'tss-react/mui';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import DeleteIcon from '@mui/icons-material/Delete';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import {Tooltip, Alert, Typography} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import  { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import jsondata from "../../../config/NewHCOFormFields.json";
import InputDetailsHCO from './detail-input-newHCO';
import hcoFormConfig from "../../../config/NewHCOFormFields.json";
import CONSTANT from '../../../Constant/Constant';
const useStyles = makeStyles()((theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(0)
    },
    nested: {
        paddingLeft: theme.spacing(1),
    },
}));

const NoMaxWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: '500px',
      fontSize: '12px',
    },
  });



const NewRelation = (props) => {
    const classes = useStyles();
    const [newRelationValue, setNewRelationValue] = useState({Rank:[{value: '1'}],Parent:[{value: true}]});
    const [addressData, setAddressData] = useState(props.newData.find((el) => {
        return el.id === 'Address'
    }));
    const [brickData, setBrickData] = useState(null);
    const [value, setValue] = useState(props.newHCP ? { HCO: '' } : { HCO: '', Rank: '' })
    const [error, setError] = useState(false);    
    const [open, setOpen] = useState(true);
    const [clear, setClear] = useState(false)
    const [keyValue, setKeyValue] = useState(true)
    const [relationSubmit, setSubmitFlag] = useState();
    const [primaryHCO, setPrimaryHCO] = useState(true)
    const [parentHCO, setParentHCO] = useState(true)
    const [showParentChildRelation, setShowParentChildRelation] = useState(true)
    const [affiliationValue, setAffiliationValue] = useState("")
    const[showInfo, setShowInfo] = useState(false)
    const [showVendorText, setShowVendorText] = useState(false)
    const [brickExpanded, setBrickExpanded] = useState(false)
    const [selectedCountryCode, setSelectedCountryCode] = useState('')
    const [brickValues, setBrickValues] = useState({
        BrickType: 'BRK',
        BrickId: '',
        BrickEffectiveStartDate: moment.utc(new Date()).format("YYYY-MM-DD"),
        BrickEffectiveEndDate: '9999-12-31',
        BrickSource: 'LLY-MNGD'
    })

    useEffect(() => {
        
        setError(props.error)

        if (props.clear) {
            
          
            setNewRelationValue({Rank:[{value: '1'}],Parent:[{value: true}]});
            setAffiliationValue("")
            setKeyValue(true)
        }
        setClear(props.clear);
        
    }, [props.error, props.clear, props.newHCP])


    useEffect(() => {
        if (!brickExpanded) {
            setSubmitFlag((oldValue) => {
                return {
                    ...oldValue,
                    BrickId: false,
                    BrickType: false,
                    BrickEffectiveStartDate: false,
                    BrickEffectiveEndDate: false,
                    BrickSource: false,
                }
            })
        }
    }, [brickExpanded])

    useEffect(() => {
        if (selectedCountryCode) {
            const countryConfig = hcoFormConfig.countries.find(c => c.country_Name === selectedCountryCode)
                                || hcoFormConfig.countries.find(c => c.country_Name === 'default');
            if (countryConfig && countryConfig.input) {
                let brickSection = null;
                Object.values(countryConfig.input).forEach((sourceArray) => {
                    if (Array.isArray(sourceArray) && !brickSection) {
                        brickSection = sourceArray.find(s => s?.id === 'BRICK');
                    }
                });
                setBrickData(brickSection);
            } else {
                setBrickData(null);
            }
        } else {
            setBrickData(null);
        }
    }, [selectedCountryCode])

    /**
     * Handle Nested Atrribute change
     * @param {*} newValue 
     * @param {*} Name 
     * @param {*} flag 
     */

    const setNewNestedValue = async (newValue, flag, Name) => {
        let submitted = false;
        let newFlag = {
            ...relationSubmit,
            [Name]: flag
        }
        if (Name === 'Country') {
            setSelectedCountryCode(newValue.value)
        }
        if (Name === 'Rank') {
            setPrimaryHCO(!primaryHCO)
            if (relationSubmit === undefined || (relationSubmit && relationSubmit.HCO === undefined)) {
                newFlag = {
                    ...relationSubmit,
                    [Name]: flag,
                    HCO: (newRelationValue && newRelationValue.HCO && newRelationValue.HCO._id) ? false : true
                }
            }
        }
        if (Name === 'Parent') {
            setParentHCO(!parentHCO)
            setAffiliationValue(null)
            if (relationSubmit === undefined || (relationSubmit && relationSubmit.HCO === undefined)) {
                newFlag = {
                    ...relationSubmit,
                    [Name]: flag,
                    HCO: (newRelationValue && newRelationValue.HCO && newRelationValue.HCO._id) ? false : true
                }
            }
        }
        if (Name === 'Affiliations') {
            setAffiliationValue(newValue.value)
            if (relationSubmit === undefined || (relationSubmit && relationSubmit.HCO === undefined)) {
                newFlag = {
                    ...relationSubmit,
                    [Name]: flag,
                    HCO: (newRelationValue && newRelationValue.HCO && newRelationValue.HCO._id) ? false : true
                }
            }
        }
        Object.keys(newFlag).forEach(res => {
            submitted = submitted || newFlag[res];
        })
        setSubmitFlag((oldValue) => {
            return {
                ...oldValue,
                [Name]: flag
            }
        })



        await setNewRelationValue({
            ...newRelationValue,
        [Name]: [newValue]
        });
        if (!submitted) {
            props.AddNewRelation({
                ...newRelationValue,
                [Name]: [newValue]
            }, submitted);

            
        } else {
            props.AddNewRelation(undefined, submitted);
        }

    }

    /**
     * Handle Delete Item
     */
    const deleteNewItem = () => {
        props.AddNewRelation(undefined)
        props.deleteNewItem();
        setKeyValue(false)
        setShowInfo(false)
    }


    /**
     * handle overall Flag computation for nested attribute
     * @returns Return overall Flag for nested attribute
     */
     const checkFlag = () => {
        return (newRelationValue && newRelationValue.Rank && newRelationValue.Rank.length > 0 && newRelationValue
            && newRelationValue.HCO && newRelationValue.HCO._id &&
            newRelationValue.Rank[0].value && newRelationValue.Rank[0].value.length > 0) ? true : false;

        }
    /**
     * Handle Add New  relation
     * @param {*} newValue 
     * @param {*} flag 
     */
     const addRelation = (newValue, flag) => {
        if (newValue._source !== '') {
            if(newValue._source.DepartmentIndicator && newValue._source?.DepartmentIndicator[0]?.value==='Y'){
                setShowParentChildRelation(false)
            }else{
                setShowParentChildRelation(true)
            }
            if (newValue._source.link !== undefined) {
                setKeyValue(false)
                setNewRelationValue({
                    ...newRelationValue,
                    HCO: [{
                        value: newValue._source.label
                    }]
                })
                props.AddNewRelation(undefined, true);
                setSubmitFlag((oldValue) => {
                    return props.newHCP ? {
                        ...oldValue,
                        HCO: false,
                        AddressLine1: true,
                        City: true,
                        Zip: true,
                        StateProvince: true,
                        Country: true,
                        ClassificationCode: true
                    } : {
                        ...oldValue,
                        HCO: false,
                        Rank: true,
                        AddressLine1: true,                    
                        City: true,
                        Zip: true,
                        StateProvince: true,
                        Country: true,
                        ClassificationCode: true
                    }
                })
            } else {
                setNewRelationValue({
                    ...newRelationValue,
                    HCO: newValue
                })
                if (props.newHCP) {
                    props.AddNewRelation({
                        ...newRelationValue,
                        HCO: newValue
                    }, flag)
                } else {
                    checkFlag() && props.AddNewRelation({
                        HCO: newValue
                    }, false)
                }

            }
        } else {
            setKeyValue(true)
            setShowInfo(false)
            setShowParentChildRelation(true)
            props.AddNewRelation(undefined, true)

        }
    }

    const getTooltipText = ()=>{
        let isPrimary = newRelationValue?.Rank ? newRelationValue.Rank[0].value === '1' ? true : false : null
        let isParent = newRelationValue?.Parent ? newRelationValue.Parent[0].value : null

        if(keyValue && isPrimary !== null && isParent !== null &&  newRelationValue.HCO){
            if(isPrimary === true && isParent === false){
                return jsondata.relation_messages.setNewHCOAsPrimaryParent
            }else if (isPrimary === false && isParent === false){
                return jsondata.relation_messages.setNewHCOAsParent
            }else if (isPrimary === true && isParent === true){
                return jsondata.relation_messages.setPrimaryParentHCO
            }else{
                return jsondata.relation_messages.setParentHCO
            }   
        }
    }

    const showMessage = ()=>{
        setShowInfo(true)
    }

    useEffect(()=>{
        if(keyValue && newRelationValue.HCO != undefined){
            showMessage()
        }
        
    },[newRelationValue])

    return (
        <div>
            <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                className={classes.root}
            >
                {props.newHCP === undefined &&
                    <ListItem className={open ? ' bg-muted' : ''}>
                        <ListItemText primary={"New"} />
                        <DeleteIcon className='pointer text-primary' onClick={deleteNewItem} />
                    </ListItem>
                }
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="div" className="bg-grey" >
                        <ListItem className={classes.nested}>
                            <ListItemText primary={

                                

                                        <div>
                                         

                                            {
                                                <div className='mt-2 newHcp-hco'>
                                                    <span className="mb-0 mt-2 newHcp-hco">{'HCO'}</span>
                                                    <span className='required-asterisk-exclusion'> *</span>
                                                    <span><Asynchronous addOnlyExistingRelation={props?.addOnlyExistingRelation} empQuery={props?.empQuery} isVendor={props.isVendor} setShowVendorText={setShowVendorText} clear={clear} error={error} country={props.country} source={props.source} addRelation={(value, flag) => { addRelation(value, flag) }} searchHCOPayload= {props.searchHCOPayload} hcoQuery={props.hcoQuery} iqviaEnnable = {props.iqviaEnnable} /></span>
                                                </div>
                                            }
                                            {
                                                <FormControlLabel
                                                label={
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                      <span id='newhcp-text'>Primary Affiliation</span>

                                                        <NoMaxWidthTooltip 
                                                        disableFocusListener
                                                        title={`Checking this option will add this HCO as the Primary workplace for the ${props?.entity ? props.entity : "HCP"}`}
                                                        id="tooltip"
                                                      >
                                                        <InfoOutlinedIcon
                                                          className="ms-1"
                                                          style={{ fontSize: 16, cursor: 'pointer', marginLeft: 4 }}
                                                        />
                                                      </NoMaxWidthTooltip >

                                                      
                                                    </div>
                                                  }                                
                                                control={<Checkbox disabled={props?.isEmployer ? true : false} checked={primaryHCO} onChange={()=>setNewNestedValue(!primaryHCO ? {value: '1'} : {value: '99'}  , false, 'Rank') } />}
                                                />                                        
                                            }
                                            { showParentChildRelation && props?.entity ==="HCO" &&
                                                <FormControlLabel
                                                label={
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                      <span id='newhcp-text'>Add as Parent</span>
                                                       <NoMaxWidthTooltip
                                                        disableFocusListener
                                                        title={"Checking this option will add this HCO as the Parent workplace for the HCO"}
                                                        id="tooltip"
                                                      >
                                                        <InfoOutlinedIcon
                                                          className="ms-1"
                                                          style={{ fontSize: 16, cursor: 'pointer', marginLeft: 4 }}
                                                        />
                                                      </NoMaxWidthTooltip> 
                                                    </div>
                                                  }                                
                                                control={<Checkbox checked={parentHCO} onChange={()=>setNewNestedValue(!parentHCO ? {value: true} : {value: false}  , false, 'Parent') } />}
                                                />                                        
                                            }
                                            {
                                                props?.entity ==="HCO" && showInfo && showParentChildRelation  &&
                                                <Alert severity="info"
                                                  sx={{ mb: 2 }}
                                                >
                                                  <span id='newhcp-text'>{getTooltipText()}</span>
                                                  </Alert>
                                            }
                                            {
                                                props?.entity ==="HCO" && props?.isVendor && showVendorText &&
                                                <Alert severity="info"
                                                  sx={{ mb: 2 }}
                                                >
                                                  <span id='newhcp-text'>{jsondata.relation_messages.noHCOFoundForVendor}</span>
                                                  </Alert>
                                            }
                                            {
                                                !keyValue &&
                                                addressData.attributes.map((el, index) => {
                                                    return (
                                                        <div key={index}>
                                                            <div className={'mt-2'}>
                                                                <span id="newhcp-text">{el.name}</span>
                                                                <span className="required-asterisk-exclusion">{el?.required ? ' *' : null}</span>
                                                                <InputDetail
                                                                    clear={clear}
                                                                    date={false}
                                                                    newHCP={true}
                                                                    error={error}
                                                                    required={el?.required}
                                                                    type={el.type}
                                                                    value={(props?.isEmployer && el?.id === 'ClassificationCode') ?  el?.value : ''} label={el.name}
                                                                    updatedValue={(newValue, flag) => { setNewNestedValue(newValue, flag, el.id) }}
                                                                    entity = {'HCO'}
                                                                    country = {props.country}
                                                                    sourceName={props.source}
                                                                    isEmployer={props?.isEmployer ? true : false}
                                                                    lovKey={props?.lovKey}
                                                                />
                                                            </div>
                                                            {el.id === 'Country' && brickData && selectedCountryCode && CONSTANT.BRICK_LILLY_MANAGED_SOURCES.includes(props.source) && (
                                                                <div className={'mt-3'}>
                                                                    <div
                                                                        className="d-flex justify-content-between align-items-center"
                                                                        style={{ padding: '8px 0 4px 0', cursor: 'pointer' }}
                                                                        onClick={() => setBrickExpanded(!brickExpanded)}
                                                                    >
                                                                        <Typography variant='subtitle1' className='fw-bold _wg-dynamic-text'>{brickData.heading}</Typography>
                                                                        <ExpandMoreIcon
                                                                            style={{
                                                                                transform: brickExpanded ? 'rotate(180deg)' : 'rotate(0)',
                                                                                transition: 'transform .2s',
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    {brickExpanded && (
                                                                        <div className="row w-100 p-0" style={{ marginTop: '12px' }}>
                                                                            {brickData.attributes.map((value, key) => {
                                                                                return (
                                                                                    <div key={key} className="col-sm-12 col-md-6 mb-2">
                                                                                        <span id="newhcp-text">{value.name}</span>
                                                                                        {value.id === 'BrickId' ? brickExpanded && <span className="required-asterisk-exclusion"> *</span> : value.required && <span className="required-asterisk-exclusion"> *</span>}
                                                                                        {value.readOnly ? (
                                                                                            <div className="w-100">
                                                                                                <span
                                                                                                    className="text-muted _wg-exclude"
                                                                                                    style={{
                                                                                                        display: 'block',
                                                                                                        padding: '6px 0 7px',
                                                                                                        borderBottom: '1px solid rgba(0,0,0,0.42)',
                                                                                                        minHeight: '32px',
                                                                                                    }}
                                                                                                >
                                                                                                    {value.id === 'BrickType' ? 'BRK' : value.id === 'BrickSource' ? 'LLY-MNGD' : brickValues[value.id] || ''}
                                                                                                </span>
                                                                                                <div style={{ height: '23px' }} />
                                                                                            </div>
                                                                                        ) : (
                                                                                            <InputDetailsHCO
                                                                                                clear={clear}
                                                                                                date={value.type === 'date'}
                                                                                                newHCO={true}
                                                                                                require={value.id === 'BrickId' ? brickExpanded : value.required}
                                                                                                error={error}
                                                                                                type={value.type}
                                                                                                value={brickValues[value.id] || ''}
                                                                                                label={value.name}
                                                                                                updatedValue={(newValue, flag) => {
                                                                                                    setNewNestedValue(newValue, flag, value.id);
                                                                                                    setBrickValues({ ...brickValues, [value.id]: newValue.value });
                                                                                                }}
                                                                                                entity={'HCO'}
                                                                                                country={props.country}
                                                                                                sourceName={props.source}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                )
                                                                            })}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )
                                                })
                                    }


                                        { 
                                                   
                                                   (props?.entity ==="HCO" || props.showRelationType != undefined && props.showRelationType ) &&
                                                   <div className='mt-2'>

                                                   <span id='newhcp-text'>{jsondata['Affiliations'].label}</span>
                                                   {!props?.isEmployer && <span className="required-asterisk-exclusion"> *</span>}
                                                    <InputDetailsHCO
                                                        clear={clear}
                                                        date={false}
                                                        newHCO={true}
                                                        error={error}
                                                        type={props?.isEmployer ? props?.relationshipTypeFields?.type : jsondata['Affiliations']?.type}
                                                        value={clear ? null : affiliationValue} label={props?.isEmployer ? props?.relationshipTypeFields?.label : jsondata['Affiliations']?.label}
                                                        updatedValue={(newValue, flag) => { setNewNestedValue(newValue, false, 'Affiliations') }}
                                                        entity={props?.entity}
                                                        virtualHCO = {true}
                                                        require = {props?.isEmployer ? props?.relationshipTypeFields?.required : jsondata['Affiliations']?.required}
                                                        source={props?.source}
                                                        isEmployer={props?.isEmployer ? true : false}
                                                        lovKey={props?.lovKey}
                                                    />
                                                </div>
                                }
                                        </div>
                                    
                                
                            } />

                        </ListItem>
                    </List>
                </Collapse>
            </List>

        </div>
    )
}

export default NewRelation;